module.exports = __webpack_public_path__ + "img/icon-sad-survey.85697a9b.svg";